const PLACEHOLDER_CLIENT_IDS = new Set([
  '',
  'YOUR_LINKEDIN_CLIENT_ID_HERE',
  'your-linkedin-client-id',
]);

const runtimeOrigin =
  typeof window !== 'undefined' && window.location?.origin
    ? window.location.origin
    : 'http://localhost:3000';

export const linkedinClientId = (process.env.REACT_APP_LINKEDIN_CLIENT_ID || '').trim();
export const linkedinRedirectUri = (
  process.env.REACT_APP_LINKEDIN_REDIRECT_URI ||
  `${runtimeOrigin}/auth/linkedin/callback`
).trim();
export const linkedinScopes = 'openid profile email';
export const isLinkedInOAuthConfigured = !PLACEHOLDER_CLIENT_IDS.has(linkedinClientId);

